import type { LightInfo } from '../../types/careExpanded';

interface LightSectionProps {
  light: LightInfo;
}

export function LightSection({ light }: LightSectionProps) {
  return (
    <div className="space-y-3">
      {/* Requirement badge */}
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-500/10 text-amber-600">
        <span className="text-sm font-medium">{light.requirement}</span>
      </div>

      {/* Placement guidance */}
      <div>
        <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
          Placement
        </dt>
        <dd className="mt-1 text-sm text-editorial-black">{light.placement}</dd>
      </div>

      {/* Additional notes */}
      {light.notes && (
        <div>
          <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
            Tips
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{light.notes}</dd>
        </div>
      )}
    </div>
  );
}
